import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { Carousel } from 'react-responsive-carousel';
import "./carousel.css";

// component
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import styles from 'views/component/Styles.js';
import ToggleInput from 'views/component/ToggleInput';
import UnityInterface from 'views/project/testcase/UnityInterface';
import TypoMuted from 'components/Typography/Muted.js';
import ProductionPlan from "./ProductionPlan";
import FacilityList from "./FacilityList";
import Routing from "./Routing";
import Clearfix from "components/Clearfix/Clearfix";

const useStyles = makeStyles(styles);
const customStyles = makeStyles({
    page: { textAlign: 'left', height: 'calc(100vh - 225px)', overflowY: 'auto' }
});

export default function ModelingPage(props) {
    const { testcase, onTestcaseChange } = props;
    const [simTime, setSimTime] = useState(0);
    const [logTime, setLogTime] = useState(0);
    const [logTerm, setLogTerm] = useState(0);
    const [unityTerm, setUnityTerm] = useState(0);
    const [facilityPop, setFacilityPop] = useState(false);
    const [selectedPage, setSelectedPage] = useState(0);
    const classes = { ...useStyles(), ...customStyles() };

    useEffect(() => {
        if (testcase) {
            setSimTime(testcase.simulateTime);
            setLogTime(testcase.logTime);
            setLogTerm(testcase.logTerm);
            setUnityTerm(testcase.unityTerm);
        }
    }, [testcase]);
    const saveSimulationSetting = function () {
        axios.post('data/testcase/edit', {
            testcaseId: testcase.testcaseId, simulateTime: simTime, logTime: logTime, name: testcase.name,
            logTerm: logTerm, unityTerm: unityTerm
        }).then(response => {
            onTestcaseChange();
            alert("저장하였습니다")
        })
    };
    const runSimulation = function () {
        axios.get('simulation/' + testcase.testcaseId).then(response => {
            alert("시뮬레이션 실행 완료하였습니다")
            onTestcaseChange();
        })
    };
    const scrollTo = function (page, e) {
        if (e) {
            page += (e.nativeEvent.wheelDelta > 0 ? -1 : 1);
        }
        setSelectedPage(page);
    }
    return (<>
        <GridContainer style={{ padding: '30px 10px' }}>
            <GridItem md={2} className={classes.center}>
                <h4><b>{testcase.name}</b></h4>
            </GridItem>
            <GridItem md={10}>
                <GridContainer>
                    <GridItem xs={6} md={2}>
                        <ToggleInput label='시뮬레이션 시간(분)' value={(simTime / 60).toFixed(0)} underlineColor='info'
                            name='simulateTime' type='number' edit onChange={(name, value) => { setSimTime(value * 60); }} />
                    </GridItem>
                    <GridItem xs={6} md={2}>
                        <ToggleInput label='데이터 수집 시작 시간(분)' value={(logTime / 60).toFixed(0)} underlineColor='info'
                            name='dataCollTime' type='number' edit onChange={(name, value) => { setLogTime(value * 60); }} />
                    </GridItem>
                    <GridItem xs={6} md={2}>
                        <ToggleInput label='웹 로그 간격(초)' value={logTerm} underlineColor='info'
                            name='logTerm' type='number' edit onChange={(name, value) => { setLogTerm(value); }} />
                    </GridItem>
                    <GridItem xs={6} md={2}>
                        <ToggleInput label='유니티 로그 간격(초)' value={unityTerm} underlineColor='info'
                            name='unityTerm' type='number' edit onChange={(name, value) => { setUnityTerm(value); }} />
                    </GridItem>
                    <GridItem xs={6} md={4}>
                        <Button color='infoOutline' onClick={() => saveSimulationSetting()}>저장</Button>
                        <Button color="info" className={classes.right} onClick={() => runSimulation()}>시뮬레이션 실행</Button>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem md={12}>
                <Carousel axis="vertical" showArrows={false} showStatus={false} showThumbs={false} dynamicHeight={false}
                    selectedItem={selectedPage} useKeyboardArrows={true} onChange={page => setSelectedPage(page)}>
                    <div className={classes.page}>
                        <div className={classes.sectionTitle}> 설비 배치 </div>
                        <div style={{ margin: '20px 0px' }}>
                            <TypoMuted><b>배치할 설비를 화면에 끌어다 놓으세요.</b></TypoMuted>
                        </div>
                        <Button size="sm" color="info" className={classes.right}
                            onClick={e => { scrollTo(1) }}>다음 단계</Button>
                        <Button size="sm" color="infoOutline" className={classes.right}
                            onClick={e => { setFacilityPop(true); }}>설비 일괄입력</Button>
                        <UnityInterface testcase={testcase} onTestcaseChange={onTestcaseChange} scenarioId={testcase.scenarioId}
                            height='calc(100vh - 400px)' />
                    </div>
                    <div className={classes.page}>
                        <div className={classes.sectionTitle}> 제품 정보 </div>
                        <div>
                            <Button size="sm" color="info" className={classes.right} onClick={e => { scrollTo(2) }}>다음 단계</Button>
                            <Button size="sm" color="infoOutline" className={classes.right} onClick={e => { scrollTo(0) }}>이전 단계</Button>
                        </div>
                        <Clearfix/>
                        <Routing testcase={testcase} onTestcaseChange={onTestcaseChange} />
                    </div>
                    <div className={classes.page}>
                        <div className={classes.sectionTitle}> 생산 계획 </div>
                        <div>
                            <Button size="sm" color="infoOutline" className={classes.right} onClick={e => { scrollTo(1) }}>이전 단계</Button>
                        </div>
                        <Clearfix/>
                        <ProductionPlan testcase={testcase} onTestcaseChange={onTestcaseChange} />
                    </div>
                </Carousel>
            </GridItem>
        </GridContainer>
        <FacilityList testcase={testcase} modal={facilityPop} onClose={() => setFacilityPop(false)} onTestcaseChange={onTestcaseChange} />
    </>
    );
}